import React, { useState } from 'react';
import { Button } from '../UI/Button';
interface IntentConfirmationProps {
  onConfirm: (understood: boolean) => void;
}
export const IntentConfirmation = ({
  onConfirm
}: IntentConfirmationProps) => {
  const [selection, setSelection] = useState<string | null>(null);
  const handleSubmit = e => {
    e.preventDefault();
    onConfirm(selection === 'yes');
  };
  return <div className="bg-white p-6 rounded-lg border-2 border-gray-300" data-id="element-252">
      <h2 className="text-2xl font-bold text-gray-800 mb-6" data-id="element-253">
        Before You Continue
      </h2>
      <p className="text-gray-700 mb-8" data-id="element-254">
        Our mission is to serve you well. The rules of engagement are not meant
        to restrict your participation but to ensure we maintain a strong and
        mutually supportive community. By creating a space where opportunities,
        ideas, and support flow freely, we can help each other achieve personal
        and professional success.
      </p>
      <form onSubmit={handleSubmit} className="space-y-6" data-id="element-255">
        <div data-id="element-256">
          <label className="block text-gray-700 font-medium mb-4" data-id="element-257">
            Do you understand and agree with this intent?
          </label>
          <div className="space-y-3" data-id="element-258">
            <div className="flex items-center" data-id="element-259">
              <input type="radio" id="yes" name="intent" value="yes" checked={selection === 'yes'} onChange={() => setSelection('yes')} required className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-260" />
              <label htmlFor="yes" className="text-gray-700 flex items-center" data-id="element-261">
                <span className="mr-2" data-id="element-262">✅</span> Yes, I totally understand
              </label>
            </div>
            <div className="flex items-center" data-id="element-263">
              <input type="radio" id="more-details" name="intent" value="more-details" checked={selection === 'more-details'} onChange={() => setSelection('more-details')} className="mr-2 h-4 w-4 border-2 border-gray-300" data-id="element-264" />
              <label htmlFor="more-details" className="text-gray-700 flex items-center" data-id="element-265">
                <span className="mr-2" data-id="element-266">❓</span> Kindly provide more details
              </label>
            </div>
          </div>
        </div>
        <Button type="submit" disabled={!selection} className="w-full py-3" data-id="element-267">
          Continue
        </Button>
      </form>
    </div>;
};